// Template text helpers, matching mhcet-notification-service's template engine.
//   SMS / WhatsApp: {#var#} slots ({#var#}{#var#} next to each other is one slot), each mapped to a variable
//   Email: named values such as {Course Name}

export const SLOT_RUN = /\{#var#\}(?:[ \t]*\{#var#\})*/gi;
export const EMAIL_PLACEHOLDER = /\{([A-Za-z][A-Za-z0-9 _.\-/]{0,48})\}/g;
export const CHANNELS = ["sms", "whatsapp", "email"];
export const CHANNEL_LABELS = { sms: "SMS", whatsapp: "WhatsApp", email: "Email" };

export const SOURCE_LABELS = {
  system: "From database",
  send: "Typed when sending",
  file: "Column in the upload file",
};

// "Course Name" -> "coursename"
export const keyOf = (label) => String(label ?? "").toLowerCase().replace(/[^a-z0-9]/g, "");

export const slotCount = (text) => (String(text ?? "").match(SLOT_RUN) || []).length;

// Keys of the {Label} values in some texts.
export const emailKeys = (...texts) => {
  const keys = new Set();
  texts.forEach((t) => {
    for (const m of String(t ?? "").matchAll(EMAIL_PLACEHOLDER)) keys.add(keyOf(m[1]));
  });
  return [...keys];
};

// Variable keys a channel of the template uses.
export const channelKeys = (template, channel) => {
  if (!template?.[channel]) return [];
  if (channel === "email") return emailKeys(template.email.subject, template.email.body, template.email.textbody);
  return [...new Set((template[channel].slots || []).map(keyOf).filter(Boolean))];
};

/**
 * The variables a channel (or all channels) uses, with their settings. Undeclared ones are required database values.
 * systemVariables: [{ name, label }] from the service.
 */
export const usedVariables = (template, channel, systemVariables = []) => {
  const keys = channel ? channelKeys(template, channel) : [...new Set(CHANNELS.flatMap((c) => channelKeys(template, c)))];
  const declared = new Map((template?.variables || []).map((v) => [v.name || keyOf(v.label), v]));
  const system = new Map(systemVariables.map((v) => [v.name, v]));
  return keys.map((name) => declared.get(name) || { name, label: system.get(name)?.label || name, source: "system", required: true });
};

// The channels a template has.
export const channelsOf = (template) => CHANNELS.filter((c) => template?.[c]);
